module.exports = __webpack_public_path__ + "img/avatar6.b5a633f2.png";